export default __webpack_public_path__ + "static/media/facebook-icon.dc4db436.svg";